import React from "react";
import { esPlannerProveedor, daServicios } from "../../utils/proveedores";
import { useSearchParams } from "react-router-dom";
import { Heading } from "../heading";
import { useVenue } from "../VenueProvider";
import ProveedoresDirectorio from "../proveedores/ProveedoresDirectorio";
import ClientesDirectorio from "./ClientesDirectorio";

const ACCENT = "#1b4d2e";

// Directorio (FRA-353): proveedores, planners y clientes son la misma
// pregunta —con quién trabaja este venue— resuelta antes en tres lugares
// distintos, o en ninguno. Planners ya vivían dentro de proveedores (con
// categoría "planner"); clientes no existían como entidad (FRA-354).
const TABS = [
  { id: "proveedores", label: "Proveedores" },
  { id: "planners", label: "Planners" },
  { id: "clientes", label: "Clientes" },
];

const DirectorioPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { proveedores, clientes } = useVenue();
  const raw = searchParams.get("tipo");
  const tipo = TABS.some((t) => t.id === raw) ? raw : "proveedores";
  const setTipo = (id) => {
    const next = new URLSearchParams(searchParams);
    next.set("tipo", id);
    setSearchParams(next, { replace: true });
  };

  // Mismo criterio que ProveedoresDirectorio: un planner con servicios
  // cuenta en las dos pestañas.
  const conteo = {
    proveedores: (proveedores || []).filter((p) => !p.archivedAt && daServicios(p)).length,
    planners: (proveedores || []).filter((p) => !p.archivedAt && esPlannerProveedor(p)).length,
    clientes: (clientes || []).filter((c) => !c.archivedAt).length,
  };

  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-6">
        <Heading level={2}>Directorio</Heading>
        <p className="text-sm text-zinc-500 mt-1">
          Con quién trabaja tu venue: proveedores, planners y clientes.
        </p>
      </div>

      <div className="rounded-xl border border-zinc-200 dark:border-zinc-700/60 bg-white dark:bg-zinc-800/50 shadow-sm overflow-hidden">
        <div className="flex border-b border-zinc-200 dark:border-zinc-700/60">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setTipo(t.id)}
              className={`flex-1 py-3 text-sm font-semibold text-center transition border-b-2 ${
                tipo === t.id
                  ? "text-zinc-900 dark:text-white"
                  : "text-zinc-400 hover:text-zinc-600 dark:hover:text-zinc-300 border-transparent"
              }`}
              style={tipo === t.id ? { borderBottomColor: ACCENT } : undefined}
            >
              {t.label}
              <span className={`ml-1.5 text-xs font-normal ${tipo === t.id ? "text-zinc-500" : "text-zinc-300"}`}>
                {conteo[t.id]}
              </span>
            </button>
          ))}
        </div>
        {tipo === "clientes" ? (
          <ClientesDirectorio />
        ) : (
          <ProveedoresDirectorio filtroTipo={tipo} />
        )}
      </div>
    </div>
  );
};

export default DirectorioPage;
